import { ref, Ref } from "vue";
import axios from "vue-app/utils/axios";
import _ from "lodash";

type JiraTemplate = {
  id: string;
  name: string;
  groupId: string;
};

type Template = {
  value: string;
  name: string;
};

const jiraTemplates: Ref<Template[]> = ref([]);

async function getJiraTemplates() {
  try {
    const response = await axios.get("/json/jira-templates");
    const tempData = Object.values(_.sortBy(response.data, (tpl: JiraTemplate) => parseInt(tpl.groupId)));
    jiraTemplates.value = [];

    tempData.forEach((item) => {
      const tempItem = { value: item.id, name: item.name };
      jiraTemplates.value.push(tempItem);
    });
    const firstItem = { value: "", name: "JIRA: Select template" };
    jiraTemplates.value.unshift(firstItem);

    return jiraTemplates.value;
  } catch (error) {
    return [];
  }
}

async function onboardingSelected() {
  const freeOnboardingArrId = ["37", "5"];
  for (let i = 0; i <= freeOnboardingArrId.length; i++) {
    const response = await axios.get(`/edrone_jira_capture/get_link?templateId=${freeOnboardingArrId[i]}`);
    const url = response.data.data.url;

    const a = document.createElement("a");
    a.target = "_blank";
    a.href = url;
    a.click();
  }
}

async function createJira(selectedTemplate: Template) {
  if (selectedTemplate.value === "") {
    return;
  }

  if (selectedTemplate.value === "37") {
    onboardingSelected();
  } else {
    try {
      const response = await axios.get(`/edrone_jira_capture/get_link?templateId=${selectedTemplate.value}`);
      const url = response.data.data.url;

      const a = document.createElement("a");
      a.target = "_blank";
      a.href = url;
      a.click();
    } catch (error) {
      alert("Cannot fetch jira link");
    }
  }
}

export { createJira, getJiraTemplates, jiraTemplates };
